<section *ngFor="let section of sections; let i = index">
  <h2 class="sec-title">{{section.title}}</h2>
  <app-dynamic-form
    [curIndex]="i"
    (formEvents)="formEventListener($event)"
    [fields]="section.fields"></app-dynamic-form>
</section>
<div class="btnContainer">
  <button class="btn purpleBtn w-25" type="button" [class.spinner] = "isLoading" [disabled]="isLoading" (click)="onFormSubmited()" [disabled]="!isValid">ثبت</button>
  <button class="btn w-25" (click)="closeForm()">انصراف</button>
</div>
